import React from 'react';

import { MDText } from 'i18n-react';

import { InfoBox } from '@motorway/mw-highway-code/alpha';

import { DOCUMENT_ERROR_TRIGGER, DOCUMENT_KINDS } from '../../DocumentCapture.helpers';
import { useImageManager } from '../hooks/useImageManager';
import LocalTexts from '../UploadDocuments.texts.json';

import styles from './DocumentErrorsInfobox.scss';

const LocalT = new MDText(LocalTexts);

export const DocumentErrorsInfobox = () => {
  const {
    hasRequestedReuploadActions,
    kind,
    sections,
    showErrorBox,
  } = useImageManager();

  const { inputs } = sections;

  const getImageErrorCount = () => {
    let count = 0;

    inputs.forEach((input) => {
      if (showErrorBox === DOCUMENT_ERROR_TRIGGER.ON_SUBMISSION && (input.isSharp === false || !input.url)) {
        count += 1;
      } else if (showErrorBox === DOCUMENT_ERROR_TRIGGER.ON_CHANGE && input.isSharp === false) {
        count += 1;
      }
    });

    return count;
  };

  const v5NoDocumentsUploaded = kind === DOCUMENT_KINDS.V5 && inputs.filter((input) => !input.url).length === 3;

  let infoBoxHeadingErrorDocuments;
  let infoboxContextText;

  switch (true) {
    case hasRequestedReuploadActions:
      infoBoxHeadingErrorDocuments = LocalT.translate('unableToAcceptText.title');
      infoboxContextText = LocalT.translate('noDocumentsUploaded.content.failedByAgent');
      break;
    case v5NoDocumentsUploaded:
      infoBoxHeadingErrorDocuments = LocalT.translate('noDocumentsUploaded.heading.needsAttention', { imagesCount: 1, photosString: 'photo' });
      infoboxContextText = LocalT.translate('noDocumentsUploaded.content.needsAttention');
      break;
    default:
      infoBoxHeadingErrorDocuments = LocalT.translate('noDocumentsUploaded.heading.needsAttention', { imagesCount: getImageErrorCount(), photosString: getImageErrorCount() > 1 ? 'photos' : 'photo' });
      infoboxContextText = LocalT.translate('noDocumentsUploaded.content.needsAttention');
  }

  const infoboxHeading = infoBoxHeadingErrorDocuments;
  const infoboxContent = infoboxContextText;

  return (
    <div className={styles.infoBoxContainer}>
      <InfoBox content={infoboxContent} heading={infoboxHeading} size='regular' variant='error'/>
    </div>
  );
};
